import { useFormContext } from "react-hook-form";

export default function UserAboutField() {
    const { register, formState } = useFormContext();
    const error = formState.errors.about;

    return (
        <div>
            <textarea
                placeholder="О себе"
                className={`universaleditmodal-right-content-about${error ? "-invalid" : ""}`}
                style={{ height: 146 }}
                {...register("description", { minLength: 5, maxLength: 500 })}
            />
            {error?.type === "minLength" && (
                <p className="universaleditmodal-right-content-invalid-message">
                    Мин. 5 символов
                </p>
            )}
            {error?.type === "maxLength" && (
                <p className="universaleditmodal-right-content-invalid-message">
                    Макс. 500 символов
                </p>
            )}
        </div>
    );
}
